import { Button as KendoButton } from '@progress/kendo-react-buttons';
import * as React from 'react';
import * as _ from 'lodash';
import { PureComponent } from '../../../dispatcher/modules';
import classNames from 'classnames';
import { PUZZLE_BUTTON_PROPS } from './Types';
import PuzzleTooltip from '../tooltip/PuzzleTooltip';
import { TOOLTIP_OMITTED_PROPS } from '../../../utility';
import WithTooltip from '../../../utility/withTooltip';

/**
 * Button component
 * */
class PuzzleButton extends PureComponent<PUZZLE_BUTTON_PROPS> {
  buttonRef: React.RefObject<KendoButton | null> = React.createRef();
  tooltip: any = null;

  get buttonEl() {
    return this.buttonRef.current.element;
  }

  render() {
    const {
      asGridAction = false,
      reverse,
      className,
      iconClass,
      titleText,
      tooltipAnchor = 'target',
      tooltipContent,
      tooltipOpenDelay = 1000,
      extraSmall,
      tooltipPosition,
      tooltipClassName = '',
      withTooltip,
      children
    } = this.props;

    const btnClassName = classNames(className, {
      'k-flex-row-reverse': reverse,
      'k-button-icon-text': !_.isUndefined(iconClass),
      'k-button-xs': asGridAction || extraSmall
    });

    const buttonProps = _.omit(this.props, ['moduleId', 'reverse', 'asGridAction', 'extraSmall', ...TOOLTIP_OMITTED_PROPS]);

    const buttonRender = (
      <KendoButton
        aria-label={titleText}
        {...buttonProps}
        className={btnClassName}
        ref={this.buttonRef}
        title={titleText}
      >
        {(_.isNull(children) || _.isUndefined(children)) ? undefined : children}
      </KendoButton>
    );

    return withTooltip
      ? (
        <>
          <WithTooltip
            className={tooltipClassName}
            context={this}
            title={titleText}
            htmlTag={'span'}
          >
            {buttonRender}
          </WithTooltip>
          <PuzzleTooltip
            anchorElement={tooltipAnchor}
            ref={(el: any) => this.tooltip = el}
            openDelay={tooltipOpenDelay}
            position={tooltipPosition}
            content={tooltipContent}
          />
        </>
      )
      : buttonRender;
  }
}

export default PuzzleButton;
